<template>
    <div class="home-goals-raii">
        <content-subheader class="home-content home-goals-raii-subheader" text="Основные цели РАИИ"/>
        <goals-icons class="home-content home-goals-raii-icons"/>
    </div>
</template>
<script>
import ContentSubheader from '@/components/content/ContentSubheader.vue'
import GoalsIcons from '@/components/goalsRaii/GoalsIcons.vue';

export default {
    name: 'HomeGoalsRaii',
    components: {
        ContentSubheader,
        GoalsIcons
    }
}
</script>